import { CheckCircle, ArrowRightLeft, Sparkles, PenLine } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { ResponseTier } from '@/types/api.types';
import { getTierLabel } from '../utils/tierColors';

export interface TierBadgeProps {
  tier: ResponseTier;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  className?: string;
}

const TIER_ICONS = {
  Exact: CheckCircle,
  Suggested: ArrowRightLeft,
  Generated: Sparkles,
  NoMatch: PenLine,
} as const;

const SIZE_CLASSES = {
  sm: 'text-xs px-1.5 py-0.5',
  md: 'text-sm px-2 py-0.5',
  lg: 'text-base px-2.5 py-1',
} as const;

const ICON_SIZES = {
  sm: 'h-3 w-3',
  md: 'h-3.5 w-3.5',
  lg: 'h-4 w-4',
} as const;

export function TierBadge({
  tier,
  size = 'md',
  showIcon = true,
  className,
}: TierBadgeProps) {
  const Icon = TIER_ICONS[tier];
  const label = getTierLabel(tier);

  return (
    <Badge
      variant={tier.toLowerCase() as 'exact' | 'suggested' | 'generated' | 'nomatch'}
      className={cn(SIZE_CLASSES[size], className)}
    >
      {showIcon && <Icon className={cn(ICON_SIZES[size], 'mr-1')} />}
      {label}
    </Badge>
  );
}
